import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SurveyUser } from "projects/shared-lib/src/lib/model/survey-user.model";
import { LocalStorageUtil } from "./../../shared/utils/local-storage.util";
import { Category, InquiryRequest, Institution, MessageType, PersistenceAction, QuestionCtrlType, SpinnerService, SurveyQuestion, ToasterService } from "projects/shared-lib/src/public-api";
import { forkJoin, of } from "rxjs";
import { finalize } from "rxjs/operators";
import { SurveyUserService } from "../../core/services/survey-user.service";
import { InquiryResponse, SurveyDetail } from "projects/shared-lib/src/public-api";
import { DataStoreService } from "../../core/services/data-store.service";
import { TranslateLanguage } from "../../shared/model/translate-language.model";
import { LanguageUtil } from "../../shared/utils/language.util";
import { TranslateService } from "@ngx-translate/core";
import { EncryptionUtil } from "../../shared/utils/encryption-util";
import { CategoryService } from "../../core/services/category.service";
import { UrlUtil } from "../../shared/utils/url.util";
import { InstitutionService } from "../../core/services/institution.service";
import { ThemeService } from "../../core/services/theme.service";
import { SubscriptionService } from "../../core/services/subscription.service";
import { NotificationSubsUtil } from "../../shared/utils/notification-subs.util";
import { LanguageService } from "../../core/services/language.service";

@Component({
    selector: 'user-types-survey',
    templateUrl: './user-type-survey.component.html',
    styleUrls: ['./user-type-survey.component.css']
})
export class UserTypeSurveyComponent implements OnInit, OnChanges {

    @Input() emailControl: FormControl;
    @Input() searchSurvey: SurveyUser;
    public category: Category = null;
    public form: FormGroup = null;
    public surveyUser: SurveyUser = null;
    private institutionQuestion = null;
    private allInstitutions: Institution[] = [];

    public CONTROL_TYPES = QuestionCtrlType;

    public allLang: TranslateLanguage[] = [];
    public currentLangCode: string;
    private userTypeName: string;

    constructor(private activatedRoute: ActivatedRoute,
        private localStorageUtil: LocalStorageUtil,
        private categoryService: CategoryService,
        private toasterService: ToasterService,
        private spinnerService: SpinnerService,
        private surveyUserService: SurveyUserService,
        private dataStoreService: DataStoreService,
        private translateService: TranslateService,
        private institutionService: InstitutionService,
        private router: Router,
        private route: ActivatedRoute,
        private encryptionUtil: EncryptionUtil,
        private themeService: ThemeService,
        private subscriptionService: SubscriptionService,
        private notificationSubsUtil: NotificationSubsUtil,
        private urlUtil: UrlUtil,
        private languageService: LanguageService,
        public languageUtil: LanguageUtil) {
    }

    private getUserTypeName(): string {
        return this.activatedRoute.snapshot.params["category"];
    }

    async ngOnInit() {
        let catReq = this.fetchCategories();
        this.setiOSNotificationToken();
        await this.fetchAllInstitutions();
        let userReq = of(null);
        this.userTypeName = this.getUserTypeName();
        this.spinnerService.show();
        catReq.pipe(finalize(() => this.spinnerService.hide()))
            .subscribe((catRes) => {
                this.fetchCategoriesSuccess(catRes);
                if (this.localStorageUtil.getSurveyId(this.userTypeName)) {
                    this.fetchSurveyUser(this.localStorageUtil.getSurveyId(this.userTypeName))
                        .subscribe(res => {
                            if (res) {
                                if (res.operationSuccess) {
                                    if (res.returnValues && res.returnValues.length) {
                                        this.surveyUser = res.returnValues[0];
                                        this.clearEmailValidator();
                                        this.setControls();
                                    }
                                } else {
                                    this.onError("Could not lead data.")
                                }

                            }
                        });
                }
            });

        this.activatedRoute.queryParams.subscribe(params => {
            this.currentLangCode = params["lang"] ? params["lang"] : "en";

        });

        this.translateService.onLangChange.subscribe((event) => {
            this.currentLangCode = event.lang ? event.lang : 'en';
        });


        this.dataStoreService.languages$.subscribe((langs) => {
            this.allLang = langs;
        });
    }

    ngOnChanges(changes) {
        if (changes?.searchSurvey?.currentValue) {
            this.surveyUser = changes.searchSurvey.currentValue;
            this.buildFormGroup();
            this.clearEmailValidator();
            this.setControls();
            this.setSurveyVariables();
        }
    }

    setiOSNotificationToken() {
        this.route.queryParams.subscribe(params => {
            // Call save ios token
            if(params["deviceToken"]) {
                var sub = this.notificationSubsUtil.toSave("", "", params["deviceToken"], this.activatedRoute.snapshot.params["category"], 2 );
                if(!sub.surverUserId) return;
                this.subscriptionService.saveiOSSubscription(sub).subscribe();

            }
        });
    }

    setIsntitutionQuestionFromSurvey() {
        if (this.category && this.category.surveyQuestions) {
            this.category.surveyQuestions.forEach(q => {
                if (q.isPathwayLauncher) {
                    this.institutionQuestion = q;
                }
            });
        }
    }

    async fetchAllInstitutions() {
        var resp = await this.institutionService.getInstitutions(new InquiryRequest()).toPromise()
        if(resp.operationSuccess) {
            this.allInstitutions = resp.returnValues;
        }
    }

    fetchSurveyUser(email: string) {
        return this.surveyUserService.getSurveyByEmail(email, this.category.id);
    }

    fetchSurveyUserRes(res) {
        if (res) {
            if (res.operationSuccess) {
                if (res.returnValues && res.returnValues.length) {
                    this.surveyUser = res.returnValues[0];
                    this.clearEmailValidator();
                    this.setControls();
                }
            } else {
                this.onError("Could not lead data.")
            }

        }
    }

    private clearEmailValidator() {
        this.emailControl.setValidators([]);
        this.emailControl.setValue("");
        this.emailControl.updateValueAndValidity();
    }

    setControls() {
        if (this.surveyUser && this.form) {
            this.surveyUser.surveyDetails.forEach(d => {
                let question = this.category.surveyQuestions.find(q => d.questionTag == q.tag);
                if (question) {
                    if (question.questionCtrlTypeId == QuestionCtrlType.MULTIPLE_CHOICE || question.questionCtrlTypeId == QuestionCtrlType.SELECT_ALL_THAT_APPLY) {
                        this.form.controls[question.id].value.push(d.answerValue);
                    } else if (question.questionCtrlTypeId == QuestionCtrlType.SINGLE_CHOICE) {
                        this.form.controls[question.id].setValue(d.answerValue);
                    } else {
                        this.form.controls[question.id].setValue(d.answerValue);
                    }
                }
            });
        }
    }

    buildFormGroup() {
        if (this.category) {
            let allControls = {};
            this.category.surveyQuestions.forEach(q => {
                allControls[q.id] = this.createFormControl(q);
            });
            this.form = new FormGroup(allControls);
        }
    }

    showEncrytedQuestion(question: SurveyQuestion) {
        if (!question.encryptedAnswer) return true;

        if (!this.surveyUser) return true;

        if (question.encryptedAnswer && this.form.controls[question.id]?.value != "") {
            let detail = this.surveyUser.surveyDetails.find(s => s.questionTag == question.tag);
            return detail == null;
        }
        return true;
    }

    createFormControl(question: SurveyQuestion): FormControl {
        let validators = [];
        if (question.requireAnswer) {
            validators.push(Validators.required);
        }
        switch (question.questionCtrlTypeId) {
            case QuestionCtrlType.NUMBERIC_TEXT: {
                validators.push(Validators.pattern('^[0-9]*$'));
                validators.push(Validators.maxLength(20));
                return new FormControl('', validators);
            }
            case QuestionCtrlType.SINGLE_CHOICE: {
                return new FormControl('', validators);
            }
            case QuestionCtrlType.MULTIPLE_CHOICE: {
                return new FormControl([], validators);
            }
            case QuestionCtrlType.SELECT_ALL_THAT_APPLY: {
                return new FormControl([], validators);
            }
            default: {
                return new FormControl('', validators);
            }
        }
    }

    eventChange(event: number[], question: SurveyQuestion) {
        let selected = event.find(e => e == -1);
        if (selected) {
            let allOptions = question.questionOptions.map(opt => opt.description);
            this.form.controls[question.id].setValue(allOptions);
        }
    }

    async saveSurvey() {
        this.form.markAsDirty();
        this.form.markAllAsTouched();
        let userTypeName = this.getUserTypeName();
        if (this.form.invalid) {
            this.toasterService.show(MessageType.VALIDATION, "Please complete all required fields.");
            return;
        }

        if (this.emailControl.invalid) {
            this.toasterService.show(MessageType.VALIDATION, "Please complete email field.");
            return;
        }
        if (this.emailControl.value != "") {
            this.localStorageUtil.saveSurveyId(userTypeName, this.emailControl.value.toUpperCase());
        }
        if (!this.surveyUser) {
            await this.setForInsert()
        } else {
            this.setForUpdate();
        }

        this.spinnerService.show();

        this.surveyUserService.saveSurvey(this.surveyUser)
            .pipe(finalize(() => this.spinnerService.hide())).
            subscribe(async res => {
                if (res.operationSuccess) {
                    if (res.returnValues.length) {
                        this.surveyUser = res.returnValues[0];

                        var queryParams: {lang; deviceToken?} = { lang: this.translateService.currentLang };

                        if(this.route.snapshot.queryParams && this.route.snapshot.queryParams.deviceToken){
                            queryParams.deviceToken = this.route.snapshot.queryParams.deviceToken;
                        }

                        this.localStorageUtil.saveSurveyUserId(this.userTypeName, this.surveyUser.id.toString());
                        this.setSurveyVariables();

                        let institutionId = this.getInstitutionId();
                        var instAnswer = this.getInstitutionSelectedId();

                        if (instAnswer) {
                            var instSelected = this.allInstitutions.find(i => i.description == instAnswer.answerValue);
                            if(instSelected) {
                                this.localStorageUtil.savePreferedInstitution(this.category.description, instSelected);
                                this.themeService.setActiveTheme(instSelected);
                                institutionId = instSelected.id;
                            }
                        } else if(institutionId) {
                            var instSelected = this.allInstitutions.find(i => i.id == institutionId);
                            if(instSelected) {
                                this.localStorageUtil.savePreferedInstitution(this.category.description, instSelected);
                                this.themeService.setActiveTheme(instSelected);
                                institutionId = instSelected.id;
                            }

                        }

                        const url = (!institutionId) ? `${this.category.description}/guidelines` : `${this.category.description}/institutions/${institutionId}/guidelines`;

                        this.spinnerService.show();
                        this.languageService
                        .getUserLanguages(this.userTypeName, institutionId).subscribe(resp => {
                            console.log("getUserLanguages response");
                            console.log(resp)
                            this.languageService.emitlangDataChange(resp);
                            this.spinnerService.hide();
                            this.router.navigate([url], { queryParams });
                        },
                        err => {
                            console.log("Lang get error")
                            console.log(err)
                            this.spinnerService.hide();
                        })
                    }
                } else {
                    this.toasterService.show(MessageType.VALIDATION, "Could not save data.");
                }
            }, this.onError);


    }

    private getInstitutionSelectedId() {
        this.setIsntitutionQuestionFromSurvey();
        if (this.surveyUser?.surveyDetails && this.institutionQuestion) {
            let instAnswer = this.surveyUser.surveyDetails.find(d => d.questionTag == this.institutionQuestion.tag);
            if (instAnswer) {
                return instAnswer;
            }
        }
        return null;
    }

    private getInstitutionId() {
        const path = this.urlUtil.getBasePath(window.location.pathname);
        const params = this.urlUtil.getParams(path, window.location.origin);

        return (params?.institutionId > 0) ? params.institutionId : this.category.preferredInstitution;
    }

    private setSurveyVariables() {
        this.localStorageUtil.saveVariables(this.getUserTypeName(), this.buildSurveyVariables());
    }

    private buildSurveyVariables(): Map<string, string> {
        let variables = new Map<string, string>();
        this.surveyUser.surveyDetails.filter(d => d.modelAction != PersistenceAction.DELETE).forEach(d => {
            let question = this.category.surveyQuestions.find(q => d.questionTag == q.tag);
            if (!question) return;
            let option = question.questionOptions.find(opt => opt.description.toString() == d.answerValue);
            if (!option || !option.variable || option.variable == "") return;
            let variableKey = option.variable;
            let val = option.description;
            variables.set(variableKey, val);
        });

        return variables;
    }

    private async setForInsert() {
        if (this.emailControl.value) {
        }
        this.surveyUser = new SurveyUser();
        this.surveyUser.email = this.emailControl.value;
        this.surveyUser.modelAction = PersistenceAction.INSERT;
        this.surveyUser.createdBy = "MOBILE_USER";
        this.surveyUser.updatedBy = "MOBILE_USER";
        this.surveyUser.userTypeId = this.category.id;
        this.surveyUser.surveyDetails = [];
        const email: string = this.emailControl.value.trim().toUpperCase();
        this.surveyUser.email = await this.encryptionUtil.encrypt(email);
        this.category.surveyQuestions.forEach(async q => {
            if (Array.isArray(this.form.controls[q.id].value)) {
                this.form.controls[q.id].value.forEach(a => {
                    let detail = new SurveyDetail();

                    detail.answerValue = a;
                    detail.createdBy = "MOBILE_USER";
                    detail.updatedBy = "MOBILE_USER";
                    detail.questionTag = q.tag;
                    detail.modelAction = PersistenceAction.INSERT;

                    this.surveyUser.surveyDetails.push(detail);
                });
            } else {
                let detail = await this.createDetail(q);

                this.surveyUser.surveyDetails.push(detail);
            }

        });
    }

    private setForUpdate() {
        this.surveyUser.modelAction = PersistenceAction.UPDATE;
        this.category.surveyQuestions.forEach(async q => {
            if (Array.isArray(this.form.controls[q.id].value)) {
                this.form.controls[q.id].value.forEach(a => {
                    let answerIndex = this.surveyUser.surveyDetails.findIndex(d => d.questionTag == q.tag && d.answerValue == a.toString());

                    if (answerIndex >= 0) {
                        this.surveyUser.surveyDetails[answerIndex].answerValue = a;
                        this.surveyUser.surveyDetails[answerIndex].modelAction = PersistenceAction.UPDATE;
                        this.surveyUser.surveyDetails[answerIndex].updatedBy = "MOBILE_USER";
                        this.surveyUser.surveyDetails[answerIndex].createdBy = "MOBILE_USER";
                    } else {
                        let detail = new SurveyDetail();

                        detail.answerValue = a;
                        detail.createdBy = "MOBILE_USER";
                        detail.updatedBy = "MOBILE_USER";
                        detail.questionTag = q.tag;
                        detail.modelAction = PersistenceAction.INSERT;

                        this.surveyUser.surveyDetails.push(detail);
                    }
                });

            } else {
                let answerIndex = this.surveyUser.surveyDetails.findIndex(d => d.questionTag == q.tag);
                if (answerIndex >= 0) {
                    this.surveyUser.surveyDetails[answerIndex].answerValue = this.form.controls[q.id].value;
                    this.surveyUser.surveyDetails[answerIndex].modelAction = PersistenceAction.UPDATE;
                    this.surveyUser.surveyDetails[answerIndex].updatedBy = "MOBILE_USER";
                    this.surveyUser.surveyDetails[answerIndex].createdBy = "MOBILE_USER";
                } else {
                    let detail = await this.createDetail(q);

                    this.surveyUser.surveyDetails.push(detail);
                }
            }
        });

        this.surveyUser.surveyDetails.forEach(d => {
            let question = this.category.surveyQuestions.find(q => q.tag == d.questionTag);
            if (question && d.modelAction == PersistenceAction.NONE) {
                d.modelAction = PersistenceAction.DELETE;
            }
        });

    }

    private async createDetail(q: SurveyQuestion) {
        let detail = new SurveyDetail();

        if (q.questionCtrlTypeId == QuestionCtrlType.FREE_TEXT && q.encryptedAnswer && this.showEncrytedQuestion(q)) {
            detail.answerValue = await this.encryptionUtil.encrypt(this.form.controls[q.id].value.toString());
        } else {
            detail.answerValue = this.form.controls[q.id].value.toString();
        }

        detail.createdBy = "MOBILE_USER";
        detail.updatedBy = "MOBILE_USER";
        detail.questionTag = q.tag;
        detail.modelAction = PersistenceAction.INSERT;

        return detail;
    }


    private onError(error) {
        this.toasterService.show(MessageType.SYSTEM_ERROR, error);
    }

    private fetchCategories() {
        let req = new InquiryRequest();
        return this.categoryService.getCategories(req);
    }

    private fetchCategoriesSuccess(res: InquiryResponse<Category>) {
        if (res.operationSuccess) {
            this.activatedRoute.params.subscribe(params => {
                let catText: string = (params["category"]) ? params["category"] : "edu-family";
                if(catText === "undefined")
                    catText = window.sessionStorage["category"];
                this.category = res.returnValues.find(c => c.description.toUpperCase() == catText.toUpperCase());
                if (this.category) {
                    this.buildFormGroup();
                    if(!params["institutionId"]) {

                        var instSelected = this.allInstitutions.find(i => i.id == this.category.preferredInstitution);
                        if(instSelected){
                            this.localStorageUtil.savePreferedInstitution(this.category.description, instSelected);
                            this.themeService.setActiveTheme(instSelected)
                        }

                    }
                } else {
                    this.toasterService.show(MessageType.VALIDATION, "Invalid category.");
                }
            })
        }
    }
}